import * as React from 'react';
import { WatchlistItem } from 'watchlist';
import { AppContext, AppContextType } from '../../AppContextType';
import { Product } from '../../Model/Product';

export interface MailtoButtonProps {
    subject: string
    recipient?: string
    items: WatchlistItem[]
}

export class MailtoButton extends React.Component<MailtoButtonProps> {
    public static contextType = AppContextType;
    public context: AppContext<Product> = {} as AppContext<Product>;

    public render() {
        const props = this.props;
        const subject = props.subject;
        const body = this.buildMailBody(props.items);
        const uri = 'mailto:' + (props.recipient || '')
            + '?subject=' + encodeURIComponent(this.translate(subject))
            + '&body=' + encodeURIComponent(body);

        return <a href={uri} className='btn btn-primary pf-wl-mailto'>{props.children}</a>;
    }

    private translate(input: string): string {
        return this.context.i18n.translate(input, []);
    }

    private buildMailBody(items: WatchlistItem[]) {
        return items.map(i => `${i.name} (${i.uri})`).join('\r\n');
    }
}
